export class staticport{
    static porturl ="http://localhost:8080//";
    // static porturl ='http://148.66.133.79:8080/AstSite/';
}